module.exports = __webpack_public_path__ + "static/media/ym.40c9da8f87a32f0e93d2556905a0ec00.svg";